module.exports = __webpack_public_path__ + "static/img/M-2.c08144f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/M-2.png
// module id = RWem
// module chunks = 0